import { render, staticRenderFns } from "./OkModal.vue?vue&type=template&id=1637719d&"
import script from "./OkModal.vue?vue&type=script&lang=js&"
export * from "./OkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports